// Carte de succès affichée après soumission réussie.
// Utilisation: <SuccessCard siteUrl={siteUrl} exploreUrl={...} t={t} />
import React from 'react';

type Props = {
  siteUrl: string;
  exploreUrl: string;
  t: Record<string, string>;
};

export function SuccessCard({ siteUrl, exploreUrl, t }: Props) {
  return (
    <div className="card">
      <h1 className="text-glow-candidate">{t.thanksTitle}</h1>
      {t.emailSent && <p style={{marginTop: 8}}>{t.emailSent}</p>}
      <p>
        <a className="button primary" href={exploreUrl} target="_blank" rel="noreferrer">
          {t.exploreOffers}
        </a>
      </p>
    </div>
  );
}
